import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import type {
  ConnectWhatsAppRequest,
  ConnectWhatsAppResponse,
  RegisterWhatsAppResponse,
  SubscribeWabaResponse,
  WhatsAppConnectionStatusResponse,
} from '../models/whatsapp-connection.types';

@Injectable({ providedIn: 'root' })
export class WhatsAppConnectionService {
  private readonly http = inject(HttpClient);
  private readonly endpoint = `${environment.apiUrl}/api/whatsapp-connection`;

  getStatus(): Observable<WhatsAppConnectionStatusResponse> {
    return this.http.get<WhatsAppConnectionStatusResponse>(this.endpoint);
  }

  connect(payload: ConnectWhatsAppRequest): Observable<ConnectWhatsAppResponse> {
    return this.http.post<ConnectWhatsAppResponse>(this.endpoint, payload);
  }

  disconnect(): Observable<void> {
    return this.http.delete<void>(this.endpoint);
  }

  register(): Observable<RegisterWhatsAppResponse> {
    return this.http.post<RegisterWhatsAppResponse>(`${this.endpoint}/register`, {});
  }

  subscribeWaba(): Observable<SubscribeWabaResponse> {
    return this.http.post<SubscribeWabaResponse>(`${this.endpoint}/subscribe-waba`, {});
  }
}
